export default __webpack_public_path__ + "static/media/UZ.707cf999.svg";